import { useStoreActions } from '~/store/store-context';
import { useMutationState } from '../useMutationState';
import { toStanfordTaxLinkRequest } from './useLinkStanfordTaxServiceTemplate.utils';
export const useLinkStanfordTaxServiceTemplate = function useLinkStanfordTaxServiceTemplate() {
    let { failureToast } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { mutateAsync } = useMutationState({
        mutationFn: (param)=>{
            let { serviceTemplateId, mapping } = param;
            return api.stanfordTax.linkServiceTemplate({
                serviceTemplateId,
                data: toStanfordTaxLinkRequest(mapping)
            });
        },
        toasts: failureToast && {
            errorMessage: failureToast.message,
            errorTestId: failureToast.testId
        }
    });
    return {
        linkStanfordTaxServiceTemplate: mutateAsync
    };
};
